import { useTheme } from '@mui/material';
import LayoutContainer from 'components/PageLayout/LayoutContainer';
import React, { ReactNode } from 'react';

interface ISidebarMenuProps {
	children?: ReactNode;
}

const SidebarMenu: React.FC<ISidebarMenuProps> = ({ children = null }) => {
	const theme = useTheme();
	return (
		<LayoutContainer
			sx={{
				px: {
					xs: 2
				},
				py: {
					xs: 3
				},
				borderRadius: 5,
				flexGrow: 1,
				overflowY: 'auto',
				overflowX: 'hidden',
				width: '100%',
				backgroundColor: theme.palette.mainPaperBackground
			}}
			data-testid="sidebar-menu"
		>
			{children}
		</LayoutContainer>
	);
};

export default SidebarMenu;
